export { CategoriesDesktop } from '@widgets/CategoriesMenu/ui/CategoriesDesktop/CategoriesDesktop';
export { CategoriesMobile } from '@widgets/CategoriesMenu/ui/CategoriesMobile/CategoriesMobile';
export { closeCategoriesModal, openCategoriesModal, categoriesModalReducer } from './model/slice/categoriesModalSlice';
